import { Directive } from '@angular/core';
import {NG_VALUE_ACCESSOR, ControlValueAccessor} from "@angular/forms";

@Directive({
  selector: '[appInputFile]',
  host : {
    "(change)" : "onChange($event.target.files)",
    "(blur)": "onTouched()"
  },
  providers: [
      { provide: NG_VALUE_ACCESSOR, useExisting: InputFileDirective, multi: true }
  ]
})
export class InputFileDirective implements ControlValueAccessor {
  value: any;
  onChange = (_) => {};
  onTouched = () => {};

  writeValue(value) {}
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
}
